import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ReactGA from "react-ga4";

// Fix: Suppress ResizeObserver loop error by flushing it manually
const debounce = (callback, delay) => {
  let timer;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(callback, delay);
  };
};

if (typeof window !== 'undefined' && typeof ResizeObserver !== 'undefined') {
  const ro = new ResizeObserver(debounce(() => {
    document.body.classList.remove('resize-observer-error');
  }, 200));

  ro.observe(document.body);

  window.addEventListener('error', (e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
      document.body.classList.add('resize-observer-error');
      e.stopImmediatePropagation();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const msg = event?.reason?.message;
    if (msg === 'ResizeObserver loop limit exceeded') {
      event.preventDefault();
    }
  });
}

// Initialize Google Analytics
ReactGA.initialize("G-WVVDJFTJ2K");
ReactGA.send("pageview");

// Mount the React app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Start measuring performance
reportWebVitals();
